import { Decorate } from './types';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { GCPServiceAuth } from '@/api/common';

/*
 * Decorate GCPService
 */
export default class GCPService extends Decorate {
  async _addToken(config: AxiosRequestConfig) {
    const apiKey = await GCPServiceAuth.getApiKey();
    config.headers['Authorization'] = `Bearer ${apiKey}`;
    return config;
  }

  async config(config: AxiosRequestConfig) {
    await super.config(config);
    if (!config.url.endsWith('api/auth/api-key')) {
      await this._addToken(config);
    }
  }
}
